import React, { useState } from 'react';

function BancoPicker({ show, bancos = [], selectedNome, onSelect, onClose }) {
  const [search, setSearch] = useState('');

  if (!show) return null;

  const filtered = bancos
    .filter(b =>
      b.codigo.toLowerCase().includes(search.toLowerCase()) ||
      b.nome.toLowerCase().includes(search.toLowerCase())
    )
    .sort((a, b) => a.nome.localeCompare(b.nome, 'pt-BR', { numeric: true }));

  function handleSelect(b) {
    onSelect(b);
    setSearch('');
  }

  function handleClose() {
    setSearch('');
    onClose();
  }

  return (
    <div
      style={{
        position: 'fixed',
        inset: 0,
        backgroundColor: 'rgba(0,0,0,0.6)',
        zIndex: 1065,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
      }}
    >
      <div
        className="modal-content"
        style={{
          width: '90%',
          maxWidth: 620,
          height: 500,
          minHeight: 500,
          maxHeight: 500,
          display: 'flex',
          flexDirection: 'column',
          borderRadius: 6,
          overflow: 'hidden',
        }}
      >
        <div className="modal-header text-white" style={{ padding: '0.35rem 1rem', background: 'linear-gradient(45deg, rgb(7, 29, 65) 0%, rgba(29, 100, 216, 1) 100%)' }}>
          <h6 className="modal-title mb-0 small">
            <i className="bi bi-bank me-2"></i>SELECIONAR BANCO
          </h6>
          <button type="button" className="btn-close btn-close-white" onClick={handleClose} />
        </div>

        <div className="modal-body" style={{ display: 'flex', flexDirection: 'column', overflow: 'hidden', padding: '1rem' }}>
          <div className="mb-3">
            <label className="form-label small fw-semibold text-muted">
              <i className="bi bi-search me-1"></i>BUSCAR
            </label>
            <input
              autoFocus
              type="text"
              className="form-control form-control-sm"
              placeholder="Buscar por código ou nome..."
              value={search}
              onChange={e => setSearch(e.target.value)}
            />
          </div>

          <div className="border rounded" style={{ overflowY: 'auto', flex: 1 }}>
            <table className="table table-hover table-sm mb-0">
              <thead className="table-light">
                <tr>
                  <th className="small">Código</th>
                  <th className="small">Nome</th>
                </tr>
              </thead>
              <tbody>
                {filtered.map(b => (
                  <tr
                    key={b.codigo}
                    style={{ cursor: 'pointer' }}
                    onClick={() => handleSelect(b)}
                    className={selectedNome === b.nome ? 'table-info' : ''}
                  >
                    <td className="small">{b.codigo}</td>
                    <td className="small">{b.nome}</td>
                  </tr>
                ))}
                {filtered.length === 0 && (
                  <tr>
                    <td colSpan={2} className="text-center text-muted small py-3">
                      <i className="bi bi-inbox me-2"></i>Nenhum banco encontrado.
                    </td>
                  </tr>
                )}
              </tbody>
            </table>
          </div>
        </div>

        <div className="modal-footer" style={{ padding: '0.4rem 1rem' }}>
          <span className="text-muted small me-auto">
            {filtered.length} registro{filtered.length !== 1 ? 's' : ''} encontrado{filtered.length !== 1 ? 's' : ''}
          </span>
          <button type="button" className="btn btn-secondary btn-sm" onClick={handleClose}>
            Fechar
          </button>
        </div>
      </div>
    </div>
  );
}

export default BancoPicker;
